import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute, NavigationEnd } from "@angular/router";
import { MasterService, MenuService } from "../services";
import { filter, map, mergeMap } from "rxjs/operators";
import { Title } from "@angular/platform-browser";

@Component({
	selector: "caass-master",
	templateUrl: "./master.component.html",
	styleUrls: ["./master.component.css"],
})
export class MasterComponent implements OnInit {
	Title: string = "DashBoard";
	applicationItemList = [];
	ShowSupportWindow: boolean = true;

	constructor(
		private masterService: MasterService,
		private router: Router,
		private activatedRoute: ActivatedRoute,
		private titleService: Title,
		private menuService: MenuService
	) {}

	ServerName: string = "CAASS";
	ShowSupportChatWindow: boolean = false;

	ngOnInit() {
		this.applicationItemList = this.activatedRoute.snapshot.data["menu"];
		this.masterService.setApplicationItemList(this.applicationItemList);

		var r = this.activatedRoute;
		while (r.firstChild) r = r.firstChild;

		if (r.snapshot) {
			this.Title = r.snapshot.data["title"];
			this.loadMasterPreferences(this.Title);
		} else {
			this.loadMasterPreferences("Dashboard");
		}

		if (!r.snapshot.data["applicationItemID"]) {
			var url = this.router.routerState.snapshot.url;
			var item = this.masterService.getCurrentApplicationItemByUrl(url);

			if (item) {
				r.snapshot.data.applicationItemID = item.ApplicationItemID;
			}
		}

		this.masterService.routeChanged();

		this.router.events
			.pipe(filter((event) => event instanceof NavigationEnd))
			.pipe(map(() => this.activatedRoute))
			.pipe(
				map((route) => {
					while (route.firstChild) route = route.firstChild;
					return route;
				})
			)
			.pipe(filter((route) => route.outlet === "primary"))
			.pipe(mergeMap((route) => route.data))
			.subscribe((event) => {
				this.SetTitle(event.title);

				if (event["title"]) {
					this.Title = event["title"];
				}
				if (!event["applicationItemID"]) {
					var url = this.router.routerState.snapshot.url;
					var item = this.masterService.getCurrentApplicationItemByUrl(url);
					if (item) {
						event.applicationItemID = item.ApplicationItemID;
					}
				}
				this.masterService.routeChanged();
			});
	}

	loadMasterPreferences(Title) {
		var result = this.menuService.MasterPreferencesSelect();
		result.subscribe(
			(response: any) => {
				if (response != null) {
					this.ServerName = response.ServerName == null ? "CAASS" : response.ServerName;
					this.ShowSupportChatWindow = response.ShowSupportChatWindow;
				}

				this.SetTitle(Title);
			},
			(error) => {
				this.ServerName = "CAASS";
			}
		);
	}

	SetTitle(page: string) {
		this.titleService.setTitle(this.ServerName + "-" + page);
	}

	/*
 this.router.events
    .filter(event => event instanceof NavigationEnd)
    .map(() => this.activatedRoute)
    .map(route => {
      while (route.firstChild) route = route.firstChild;
      return route;
    })
    .filter(route => route.outlet === 'primary')
    .mergeMap(route => route.data)
    .subscribe((event) => {
      
      if (!event["applicationItemID"]) {
        event.applicationItemID="14567";
      }

    });
 */
}
